import { render, staticRenderFns } from "./privacyPolicyAgreement.popup-chunk.vue?vue&type=template&id=08658b30"
import script from "./privacyPolicyAgreement.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./privacyPolicyAgreement.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./privacyPolicyAgreement.popup-chunk.vue?vue&type=style&index=0&id=08658b30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports